module.exports = __webpack_public_path__ + "img/Multi-Agent_Content.a625992c.jpg";